module.exports = __webpack_public_path__ + "static/media/13Demo Photo-ink-min.4da0e941.jpeg";